<template>
  <main>
    <this-background v-if="selItem" :item="selItem" />
    <this-catalog :items="items" @select="handleSelect" />
  </main>
</template>

<script>
import axios from "axios";
import ThisBackground from "./background";
import ThisCatalog from "./catalog";

export default {
  name: "Slider",

  components: {
    ThisBackground,
    ThisCatalog
  },

  data() {
    return {
      items: [],
      selItem: null
    };
  },

  mounted() {
    this.fetchItems();
  },

  methods: {
    async fetchItems() {
      try {
        this.catalogSlider = null;
        this.catalogKey += 1;

        const { data } = await axios.get("items.json");
        this.items = data;
      } catch (error) {
        // eslint-disable-next-line no-console
        console.error(error);
      }
    },

    handleSelect(item) {
      this.selItem = JSON.parse(JSON.stringify(item));
    }
  }
};
</script>
